export function LoadingIndicator({
    loading = true,
    children = null,
}: {
    loading?: boolean
    children?: React.ReactNode
}) {
    if (loading) {
        return (
            <div className="relative min-h-96 ">
                <div className="absolute inset-0 z-10 flex animate-pulse  items-center justify-center bg-white/60">
                    Loading...
                </div>
                {children}
            </div>
        )
    }
    return children
}
